// Strips markdown formatting syntax, leaving only plain text.
export const cleanMarkdownFormatting = (text) => {
  return text
    .replace(/\*{1,3}([^*]+)\*{1,3}/g, '$1')
    .replace(/_{1,3}([^_]+)_{1,3}/g, '$1')
    .replace(/[*_]/g, '')
    .replace(/`([^`]+)`/g, '$1')
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    .replace(/!\[[^\]]*\]\([^)]+\)/g, '')
    .replace(/<[^>]+>/g, '')
    .replace(/[~`]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
};

// Converts heading text to a URL-safe anchor ID.
export const createId = (text) => {
  if (!text) return '';

  const specialCharMap = {
    '+': 'plus',
    '&': 'and',
    '/': 'or',
    '$': 'dollar',
    '@': 'at',
    '%': 'percent',
    '^': 'caret',
    '=': 'equals',
  };

  return text
    .toString()
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[+&/$@%^=]/g, match => `-${specialCharMap[match]}-`)
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
};

// Counts words in markdown content, excluding code blocks and HTML tags.
export const countWords = (content) => {
  const cleaned = content
    .replace(/```[\s\S]*?```/g, '')
    .replace(/`[^`\n]+`/g, '')
    .replace(/<[^>]*>/g, '');
  const words = cleaned.match(/\b[\w']+\b/g);
  return words ? words.length : 0;
};
